import React from 'react';
import { motion } from 'framer-motion';
import { Settings, ArrowRight, CheckCircle2 } from 'lucide-react';
const comparisonData = [{
  sit: 'Tu velocidad de producción',
  sin: '1 mueble cada 3 días',
  con: '5 muebles en la misma semana'
}, {
  sit: 'Precisión de tus cortes',
  sin: 'Medir 20 veces por pieza',
  con: 'Jigs permanentes: cero medición'
}, {
  sit: 'Corte de placas',
  sin: 'Vos cortás todo manualmente',
  con: 'Corralón industrial corta, vos ensamblás'
}, {
  sit: 'Tu inventario de insumos',
  sin: '20 tipos de tornillos que nunca encontrás',
  con: '5 tipos estándar siempre disponibles'
}, {
  sit: 'Cuando tenés 5 pedidos juntos',
  sin: 'Estrés total, plazos incumplidos',
  con: 'Tablero visual, flujo controlado'
}, {
  sit: 'Cuando incorporás un ayudante',
  sin: 'No sabés cuánto cobrar',
  con: 'Fórmula de costos con escala lista'
}, {
  sit: 'Tu negocio sin vos',
  sin: 'Para completamente',
  con: 'Jigs + sistema = funciona con ayudante'
}, {
  sit: 'Tu facturación mensual',
  sin: '$600.000 a $900.000 ARS',
  con: '$1.400.000 a $2.100.000 ARS'
}];
const modules = [{
  title: 'Módulo 1 — La Mentalidad de Micro-Fábrica',
  desc: 'El techo del artesano diagnosticado. La diferencia entre trabajar EN el negocio y trabajar PARA el negocio. Las 3 métricas que determinan si tu taller es rentable.'
}, {
  title: 'Módulo 2 — Jigs Maestros de Producción Permanentes',
  desc: 'Cómo construir guías de taller en MDF que garantizan precisión de 0.5mm en cada uso. 5 Jigs Maestros con planos completos: cazoleta, rieles, ángulos de pata, plantilla de despiece y tope de profundidad universal.'
}, {
  title: 'Módulo 3 — Producción por Lotes',
  desc: 'La Regla de 5: cómo fabricar 5 mesas rebatibles en el tiempo que hoy tardás 2. Cómo organizar tu taller en celdas de producción. El calendario semanal de la Micro-Fábrica.'
}, {
  title: 'Módulo 4 — Tercerización Inteligente del Corte',
  desc: 'Cómo usar los centros de corte industrial como tu departamento externo. La planilla de pedido Pro que elimina errores del operario. Protocolo de recepción de 3 minutos.'
}, {
  title: 'Módulo 5 — Estandarización e Inventario Inteligente',
  desc: 'La Dieta de Insumos: 5 tornillos, 3 pegamentos, 6 herrajes para el 90% de los proyectos. Sistema Kanban de 2 cajas. Cómo negociar precio de gremio con proveedores mayoristas.'
}, {
  title: 'Módulo 6 — De Operador a Dueño',
  desc: 'Cuándo y cómo contratar el primer ayudante. Los primeros 30 días de entrenamiento. La fórmula de costos correcta cuando escalás. Tu sueldo de dueño vs la ganancia del negocio.'
}, {
  title: 'Módulo 7 — Control de Calidad Industrial',
  desc: 'El protocolo de inspección de 10 puntos en menos de 10 minutos. Sistema de embalaje para venta a distancia. Formulario de registro de pruebas de carga para tu protección legal.'
}, {
  title: 'Hoja de Ruta — De 0 a Micro-Fábrica en 30 días',
  desc: 'Plan semana a semana con tareas concretas y métricas de éxito. Tabla de resultados esperados al día 90.'
}];
export function MicroFabrica() {
  return <section className="py-24 bg-white" data-id="element-226">
      <div className="container mx-auto px-4" data-id="element-227">
        <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-228">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center p-4 bg-amber/10 rounded-full mb-6" data-id="element-229">
            <Settings className="w-12 h-12 text-amber-dark animate-[spin_10s_linear_infinite]" data-id="element-230" />
          </motion.div>
          <h2 className="text-3xl md:text-5xl font-black text-wood-dark mb-6" data-id="element-231">
            ¿Qué agrega el SISTEMA MICRO-FÁBRICA™?
          </h2>
          <p className="text-2xl font-serif text-amber-dark font-bold mb-4" data-id="element-232">
            Tu sistema de producción, escala e identidad profesional.
          </p>
          <p className="text-lg text-charcoal/80 italic" data-id="element-233">
            "Porque los muebles que fabricás ya eran extraordinarios. Este
            sistema hace que tu taller funcione sin que vos estés parado ahí 12
            horas por día."
          </p>
        </div>

        {/* Comparison Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-5xl mx-auto mb-20 overflow-x-auto" data-id="element-234">
          <table className="w-full text-left border-collapse min-w-[800px]" data-id="element-235">
            <thead data-id="element-236">
              <tr data-id="element-237">
                <th className="p-4 bg-cream-dark text-wood-dark font-bold border-b-2 border-wood-light/20 w-1/3 rounded-tl-xl" data-id="element-238">
                  Situación
                </th>
                <th className="p-4 bg-red-50 text-red-900 font-bold border-b-2 border-red-200 w-1/3" data-id="element-239">
                  Sin Sistema Micro-Fábrica
                </th>
                <th className="p-4 bg-amber/20 text-wood-dark font-bold border-b-2 border-amber w-1/3 rounded-tr-xl" data-id="element-240">
                  Con Sistema Micro-Fábrica
                </th>
              </tr>
            </thead>
            <tbody data-id="element-241">
              {comparisonData.map((row, index) => <tr key={index} className="border-b border-wood-light/10 hover:bg-cream/50 transition-colors" data-id="element-242">
                  <td className="p-4 font-medium text-wood-dark" data-id="element-243">{row.sit}</td>
                  <td className="p-4 text-red-800/70" data-id="element-244">{row.sin}</td>
                  <td className="p-4 text-wood-dark font-bold bg-amber/5 flex items-center" data-id="element-245">
                    <ArrowRight className="w-4 h-4 text-amber mr-2 flex-shrink-0" data-id="element-246" />
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </motion.div>

        {/* Modules */}
        <div className="max-w-4xl mx-auto" data-id="element-247">
          <h3 className="text-2xl md:text-3xl font-black text-wood-dark mb-10 text-center" data-id="element-248">
            SISTEMA MICRO-FÁBRICA™ INCLUYE:
          </h3>
          <div className="space-y-6" data-id="element-249">
            {modules.map((mod, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="flex bg-cream-dark rounded-xl p-6 border border-wood-light/10 hover:shadow-warm transition-shadow" data-id="element-250">
                <CheckCircle2 className="w-8 h-8 text-amber flex-shrink-0 mr-4" data-id="element-251" />
                <div data-id="element-252">
                  <h4 className="text-xl font-bold text-wood-dark mb-2" data-id="element-253">
                    {mod.title}
                  </h4>
                  <p className="text-charcoal/70 leading-relaxed" data-id="element-254">{mod.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}